
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4.634L4.167 9.301v6.532h4.166V12.5h3.334v3.333h4.166V9.702a.832.832 0 00-.312-.651L10 4.634zM10 2.5l6.562 5.25A2.5 2.5 0 0117.5 9.7v6.133a1.666 1.666 0 01-1.667 1.667H4.167A1.667 1.667 0 012.5 15.833V9.301A1.667 1.667 0 013.125 8L10 2.5z"}})])
          )
        }
      }
    